module.exports = __webpack_public_path__ + "img/logo-new.765bff5d.png";